import { TrainingToolPreviewProps } from '../interface/interface';
import { PdfPreview } from '../views/DocPreviewer';
import CustomModal from './CustomModal';

export const TrainingToolPreviewer = (props: TrainingToolPreviewProps) => {
  return props.isVideo ? (
    <CustomModal
      isOpen={props.open}
      onClose={() => {
        props.closePreview();
        props.setOpen(false);
      }}
      header={props.profileName || ''}
      disableBackdropClose
    >
      {props.previewUrl ? (
        <video
          controls
          controlsList={props.isAdmin ? '' : 'nodownload'}
          onContextMenu={(e) => e.preventDefault()}
          disablePictureInPicture
          className="w-full h-auto"
        >
          <source src={props.previewUrl} type="video/mp4" />
        </video>
      ) : (
        <></>
      )}
    </CustomModal>
  ) : (
    <PdfPreview
      previewUrl={props.previewUrl}
      profileName={props.profileName}
      closePreview={props.closePreview}
      previewBlob={props.previewBlob}
      needDownload={props.isAdmin ?? false}
    />
  );
};
